// extracted by mini-css-extract-plugin
export var dot = "L_cn";
export var dotAnimate = "L_cq";
export var dotBlue = "L_cs";
export var dotGreen = "L_cr";
export var rotation = "L_cp";